import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { SkyLightStateless } from 'react-skylight';
import { Grid, Row, Col, Panel, Button, Table, Image, Breadcrumb, ButtonToolbar, DropdownButton, MenuItem, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize, I18n } from 'react-redux-i18n';
import { browserHistory } from 'react-router';
import classNames from 'classnames';
import { Field, FieldArray, reset } from 'redux-form';
import { AfterAddonField, AfterAddonPercentField, AfterAddonPercentControlField } from '../Common/afterAddonField';
import { ControlledInputField } from '../Common/inputField';
import { InputField, DisabledInputField, ControllabledStateInputField } from '../Common/inputField';
import { Selection, SelectionWithProps } from '../Common/selection';
import ConfirmActionModal from '../Common/confirmActionModal';
import PriceFormatter from '../Common/priceFormatter';
import CashFormatter from '../Common/cashFormatter';
import moment from 'moment';
import checkPermission from '../Common/permissions';
import {
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isGGI, isSH, isAP, isOCM, isSV,
  isDAICHEONG, isLE, isHO, isJRC, isESC, isABBLE, isHMM, isSUN, isLAP, isAPD, isOLG, isVAK, isGFD
} from '../../actions/root_url';
import { DateFormatter } from '../Common/dateFormat';

// class RowRenderer extends Component {
//     setScrollLeft(scrollBy) {
//         // To freeze couple columns
//         this.refs.row.setScrollLeft(scrollBy);
//     }
//
//     getRowStyle() {
//         return {
//             color: this.getRowBackground()
//         }
//     }
//
//
//     getRowBackground() {
//       return this.props.row.Description;
//     }
//     render() {
//         //here we are just changing the style
//         //but we could replace this with anything we liked, cards, images, etc
//         //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
//         return (<div style={this.getRowStyle() }><ReactDataGrid.Row ref="row" {...this.props} /></div>)
//     }
// }
class RowRenderer extends Component {
  getRowStyle() {
    return {
      color: this.getRowBackground(),
    };
  }

  getRowBackground() {
    if(isVAK && (this.props.row.orderStatus === 'open' || this.props.row.quantity == 0)) {
      return 'red'
    }
    return this.props.row.orderStatus === 'open' ? 'red' : 'black';
  }


  render() {
    //here we are just changing the style
    //but we could replace this with anything we liked, cards, images, etc
    //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
    return (
      <div
        style={this.getRowStyle()}
        // onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }}
      >
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}

class RowSalesHisRenderer extends Component {
  getRowStyle() {
    return {
      color: this.getRowBackground(),
    };
  }

  getRowBackground() {
    return ((isLAP || isAPD) || isGGI || isOLG || isVAK) && this.props.row.Presale != 0 ? 'red' : 'black';
  }


  render() {
    //here we are just changing the style
    //but we could replace this with anything we liked, cards, images, etc
    //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
    return (
      <div
        style={this.getRowStyle()}
        // onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }}
      >
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}

function generateTodaysDate() {
  return new Date();
}
class InventoryDetail extends Component {
    static contextTypes = {
      router: React.PropTypes.object,
    };

    constructor() {
      super();
      this.state = {
        tableHeight: 200,

        productNum: null,
        productType: null,
        refNum: null,
        instock: null,
        purchased: null,
        available: null,

        p1Percentage: 0,
        p2Percentage: 0,
        p3Percentage: 0,
        p4Percentage: 0,
        p5Percentage: 0,
        priceLv1: 0,
        priceLv2: 0,
        priceLv3: 0,
        priceLv4: 0,
        priceLv5: 0,

        rows: [],
        editedRows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,

        history: {
          rows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },

        inventoryAdjustment: {
          rows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },

        adjustmentOpen: false,
        enableAdjustment: false,
        ReceiveFromDate: new Date(generateTodaysDate().getTime() - (7 * 24 * 60 * 60 * 1000)),
        ReceiveToDate: generateTodaysDate(),
        FromDate: new Date(generateTodaysDate().getTime() - (7 * 24 * 60 * 60 * 1000)),
        ToDate: generateTodaysDate(),
        days: {
          label: `7 ${I18n.t('days')}`,
          value: '7',
        },
        receiveDays: {
          label: `7 ${I18n.t('days')}`,
          value: '7',
        },
        total_price: null,
        total_worth: null,
        // activeTransactionType: 'all',
        // activeTransactionTypeInTitle: 'All Transaction',
      };

      this.handleResize = this.handleResize.bind(this);
      this.openAdjustment = this.openAdjustment.bind(this);
      this.closeAdjustment = this.closeAdjustment.bind(this);
      this.enableAdjustment = this.enableAdjustment.bind(this);
      this.handlePercentageChange = this.handlePercentageChange.bind(this);
      this.handlePriceChange = this.handlePriceChange.bind(this);
      console.log('constructor')
    }

    componentWillMount() {
      this.props.resetQuickInventoryAdjustments();
      // this.setState({ FromDate: new Date(moment().subtract('3', 'months').format('MM-DD-YY')), ToDate: new Date(moment().format('MM-DD-YY')) });
    }

    componentDidMount() {
      const { currentInventory } = this.props;
      window.addEventListener('resize', this.handleResize);
      this.props.fetchCRVValues();
      this.props.fetchZones();
      // this.props.fetchInventoriesDetails();
      this.props.handleInventoryClick(this.props.params.id)
      this.props.fetchReceiveHistoryFilterInitial();
      const selectedCompanyId = this.props.selectedCompany && this.props.selectedCompany.value;
      const selectedWarehouseId = this.props.selectedWarehouse && this.props.selectedWarehouse.value;
      if (isGFD) {
        if (selectedCompanyId && selectedWarehouseId) {
          this.props.fetchInventoryDetail(this.props.params.id, selectedCompanyId, selectedWarehouseId);
        }
        this.props.fetchProductDetail(this.props.params.id);
        if(selectedWarehouseId) {
          this.props.fetchInventoryHistory(this.props.params.id, this.state.FromDate, this.state.ToDate, selectedWarehouseId);
        }
      } else {
        if (currentInventory) {
          this.props.fetchInventoryDetail(currentInventory.ProductNum, selectedCompanyId, selectedWarehouseId);
          this.props.fetchProductDetail(currentInventory.Product_id);
          this.props.fetchInventoryHistory(currentInventory.Product_id, this.state.FromDate, this.state.ToDate);
        } else if (this.props.params.id) {
          if (selectedCompanyId && selectedWarehouseId) {
            this.props.fetchInventoryDetail(this.props.params.id, selectedCompanyId, selectedWarehouseId);
          }
          this.props.fetchProductDetail(this.props.params.id);
          this.props.fetchInventoryHistory(this.props.params.id, this.state.FromDate, this.state.ToDate);
        }
      }

    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    componentWillReceiveProps(nextProps) {
      /* if (nextProps.routeParams.id) {
        this.props.fetchProductDetail(nextProps.routeParams.id);
        this.props.fetchInventoryDetail(nextProps.currentProductDetail.ProductNum);
        this.props.fetchInventoryHistory(nextProps.currentProductDetail.Product_id, this.state.FromDate, this.state.ToDate);
      } */
      if (this.props.selectedWarehouse !== nextProps.selectedWarehouse && nextProps.selectedWarehouse) {
        const selectedCompanyId = nextProps.selectedCompany && nextProps.selectedCompany.value;
        const selectedWarehouseId = nextProps.selectedWarehouse && nextProps.selectedWarehouse.value;
        if (selectedCompanyId && selectedWarehouseId) {
          this.props.fetchInventoryDetail(this.props.params.id, selectedCompanyId, selectedWarehouseId);
          if (isGFD) {
            this.props.fetchInventoriesDetails(this.props.params.id, selectedCompanyId, selectedWarehouseId);
            this.props.fetchInventoryHistory(this.props.params.id, this.state.FromDate, this.state.ToDate, selectedWarehouseId);
            this.props.fetchReceiveHistory(this.props.params.id, selectedWarehouseId);
          }
        }
      }
      if (nextProps.ConvertType && nextProps.ConvertType != this.props.ConvertType) {
        let convertNum = null;
        if (this.props.currentProductDetail) {
          if (nextProps.ConvertType == 'weight') {
            convertNum = this.props.currentProductDetail.NetWeight;
          } else if (nextProps.ConvertType == 'unit') {
            convertNum = this.props.currentProductDetail.PackageSize_1;
          }
          if (nextProps.currentProductDetail.Default_WarehouseZone_id) {
            this.props.fetchBins(nextProps.currentProductDetail.Default_WarehouseZone_id);
          }
        }
        this.props.setValue('inventoryDetail', 'ConvertNum', convertNum);
      }
      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess != this.props.checkPasswordSuccess) {
        this.closeAdjustment();
        this.setState({ enableAdjustment: true });
      }
      if (nextProps.checkPasswordFailure && nextProps.checkPasswordFailure != this.props.checkPasswordFailure) {
        this.setState({ enableAdjustment: false });
      }
      if (nextProps.currentInventoryDetail != null) {
        const productNum = nextProps.currentInventoryDetail.ProductNum;
        const productType = nextProps.currentInventoryDetail.ProductType;
        const refNum = nextProps.currentInventoryDetail.RefNum;
        const inStock = nextProps.currentInventoryDetail.InStock;
        const purchased = nextProps.currentInventoryDetail.Purchased;
        const available = nextProps.currentInventoryDetail.AvailableStock;
        const rows = nextProps.currentInventoryDetail.Products;
        const PreSale = nextProps.currentInventoryDetail.PreSale;
        const TotalWeight = nextProps.currentInventoryDetail.TotalWeight;
        // rows.map(row => {
        //   row['ZoneName'] = row.WarehouseZone_id.Name;
        //   // row['BinName'] = row.WarehouseBin_id.Name;
        //   // row['Description'] = row.WarehouseBin_id.Description;
        // })
        this.setState({
          productNum,
          productType,
          refNum,
          inStock,
          purchased,
          available,
          rows,
          PreSale,
          TotalWeight,
        });
      }
      if (nextProps.currentProductDetail && nextProps.currentProductDetail != this.props.currentProductDetail) {
        this.setState({
          p1Percentage: nextProps.currentProductDetail.P1Percentage,
          p2Percentage: nextProps.currentProductDetail.P2Percentage,
          p3Percentage: nextProps.currentProductDetail.P3Percentage,
          p4Percentage: nextProps.currentProductDetail.P4Percentage,
          p5Percentage: nextProps.currentProductDetail.P5Percentage,
          priceLv1: nextProps.currentProductDetail.PriceLv1,
          priceLv2: nextProps.currentProductDetail.PriceLv2,
          priceLv3: nextProps.currentProductDetail.PriceLv3,
          priceLv4: nextProps.currentProductDetail.PriceLv4,
          priceLv5: nextProps.currentProductDetail.PriceLv5,
        });
      }
      // if (nextProps.inventoryHistory && nextProps.inventoryHistory != this.props.inventoryHistory) {
      //   const history = { ...this.state.history, rows: nextProps.inventoryHistory };
      //   this.setState({ history });
      // }
      if(nextProps.inventoryBatchLogDetail) {
        let t = nextProps.inventoryBatchLogDetail.sales_data && nextProps.inventoryBatchLogDetail.sales_data;
        t.map(item=>{
          if(item.SalesOrder && item.SalesOrder.SONum) {
            item.SONumber = item.SalesOrder.SONum;
          }
          if(item.SalesInvoice && item.SalesInvoice.InvoiceNum) {
            item.invoice_number = item.SalesInvoice.InvoiceNum;
          }
        })
        this.setState({
          inventoryAdjustment: {
            rows: t,
          },
          total_price: nextProps.inventoryBatchLogDetail.total_price,
        })
      }
      if(this.props.filters !== nextProps.filters && nextProps.filters) {
        //fetch new info with filter
        const company = this.props.selectedCompany && this.props.selectedCompany.value;
        const warehouseId = this.props.selectedWarehouse && this.props.selectedWarehouse.value;
        if (isVAK || isSH || isAP || isGFD) {
          if (company && warehouseId) {
            this.props.fetchInventoriesDetails(nextProps.params.id, company, warehouseId);
          }
        } else {
          this.props.fetchInventoriesDetails(nextProps.params.id);
        }
      }

      if(this.props.receiveTableFilter !== nextProps.receiveTableFilter && nextProps.receiveTableFilter) {
        const company = this.props.selectedCompany && this.props.selectedCompany.value;
        const warehouseId = this.props.selectedWarehouse && this.props.selectedWarehouse.value;
        if (isVAK || isSH || isAP || isGFD) {
          if (warehouseId) {
            this.props.fetchReceiveHistory(nextProps.params.id, warehouseId);
          }
        } else {
          this.props.fetchReceiveHistory(nextProps.params.id);
        }
      }

      if(nextProps.productReceiveHistory !== this.props.productReceiveHistory) {
        this.setState({
          history: {
            rows: nextProps.productReceiveHistory.purchase_data
          },
          total_worth: nextProps.productReceiveHistory.total_worth,
        }, () => {
          console.log('productReceiveHistory',  this.state);
        })
      }

      // if(nextProps.)
    }

    handleResize(e) {
      // this.setState({tableHeight: (window.innerHeight > UI_HEIGHT.inventoryDetailPage) ? window.innerHeight - UI_HEIGHT.inventoryDetailPage : window.innerHeight - UI_HEIGHT.heightLess490 });
    }

    handleKeyPress(value, event) {
      if (event.charCode == 13) {
        event.preventDefault();
        ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      }
    }

    handleOnFocus(event) {
      event.target.select();
    }

    openAdjustment() {
      this.props.clearCheckPassword();
      this.setState({ adjustmentOpen: true });
    }

    closeAdjustment() {
      this.setState({ adjustmentOpen: false });
    }

    enableAdjustment(password) {
      this.props.checkPassword(password);
    }

    calculatePriceLevel(pricePer, refPrice) {
      const price = (((parseFloat(pricePer) || 0) + 100) * (parseFloat(refPrice) || 0) * 0.01).toFixed(2);
      let val = parseInt(price * 100);
      val = (val / 100).toFixed(2);
      val = (price - val > 0) ? parseFloat(val) + 0.01 : val;
      val = parseFloat(val).toFixed(2);
      return val;
    }

    calculatePricePercentage(price, refPrice) {
      return ((parseFloat(price) || 0) / (parseFloat(refPrice) || 0) * 100 - 100).toFixed(2);
    }

    handlePercentageChange(level, event) {
      const price = this.calculatePriceLevel(event.target.value, this.props.RefPriceValue);
      switch (level) {
        case 'p1Percentage':
          this.setState({ p1Percentage: event.target.value, priceLv1: price });
          break;
        case 'p2Percentage':
          this.setState({ p2Percentage: event.target.value, priceLv2: price });
          break;
        case 'p3Percentage':
          this.setState({ p3Percentage: event.target.value, priceLv3: price });
          break;
        case 'p4Percentage':
          this.setState({ p4Percentage: event.target.value, priceLv4: price });
          break;
        case 'p5Percentage':
          this.setState({ p5Percentage: event.target.value, priceLv5: price });
          break;
        default:
          break;
      }
    }

    handlePriceChange(level, event) {
      const percentage = this.calculatePricePercentage(event.target.value, this.props.RefPriceValue);
      switch (level) {
        case 'priceLv1':
          this.setState({ priceLv1: event.target.value, p1Percentage: percentage });
          break;
        case 'priceLv2':
          this.setState({ priceLv2: event.target.value, p2Percentage: percentage });
          break;
        case 'priceLv3':
          this.setState({ priceLv3: event.target.value, p3Percentage: percentage });
          break;
        case 'priceLv4':
          this.setState({ priceLv4: event.target.value, p4Percentage: percentage });
          break;
        case 'priceLv5':
          this.setState({ priceLv5: event.target.value, p5Percentage: percentage });
          break;
        default:
          break;
      }
    }

    roundUp(price) {
      price = parseFloat(price);
      let val = parseInt(price * 10);
      val /= 10;
      const left = (price - val).toFixed(8);
      let rounded = 0;
      if (left == 0) {
        rounded = 0;
      } else if (left > 0 && left <= 0.05) {
        rounded = 0.05;
      } else if (left > 0.05 && left <= 0.09) {
        rounded = 0.09;
      } else {
        rounded = 0.1;
      }
      rounded += val;
      rounded = rounded.toFixed(2);
      return rounded;
    }

    getZoneOptions() {
      const zoneOptions = [];
      this.props.zones.map((zone) => {
        zoneOptions.push({ value: zone.WarehouseZone_id, label: zone.Name });
      });
      return zoneOptions;
    }

    getBinOptions() {
      const binOptions = [];
      this.props.bins.map((bin) => {
        binOptions.push({ value: bin.WarehouseBin_id, label: bin.Name });
      });
      return binOptions;
    }

    handleZoneOnChange = () => {
      let { zoneID } = this.props;
      if (zoneID) {
        zoneID = (typeof zoneID === 'object') ? zoneID.value : zoneID;
        this.props.fetchBins(zoneID);
      }
    }

    renderAvgCost() {
      // if(this.props.currentProductDetail) {
      return (
        <Col xs={6} className="avg-and-inv-cost">
          <div className="form-group">
            <label className="col-xs-6"><Translate value="avg_cost" /></label>
            <div className="col-xs-6">
              <Field
                name="InStockPrice"
                withRef
                ref="InStockPrice"
                component={InputField}
                onFocus={this.handleOnFocus}
                onKeyPress={(event) => {
                  this.handleKeyPress('ProductCost', event);
                }}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="col-xs-6"><Translate value="prod_cost" /></label>
            <div className="col-xs-6">
              <Field
                name="ProductCost"
                withRef
                ref="ProductCost"
                component={InputField}
                onFocus={this.handleOnFocus}
                onKeyPress={(event) => {
                  this.handleKeyPress('RefPrice', event);
                }}
              />
            </div>
          </div>
        </Col>
      );
      // }
      // else {
      //   return (
      //     <div>
      //       <div className="form-group">
      //           <label className="col-xs-6"><Translate value="inv_cost" /></label>
      //           <div className="col-xs-6">
      //             <Field name="NetCost" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="NetCost" onKeyPress={(event) => {
      //                 this.handleKeyPress('ProductCost', event)
      //             }}/>
      //         </div>
      //       </div>
      //       <div className="form-group">
      //           <label className="col-xs-6"><Translate value="prod_cost" /></label>
      //           <div className="col-xs-6">
      //             <Field name="ProductCost" component={ InputField } onFocus={this.handleOnFocus} withRef={true} ref="ProductCost" onKeyPress={(event) => {
      //                 this.handleKeyPress('RefPrice', event)
      //             }}/>
      //         </div>
      //       </div>
      //     </div>
      //   )
      // }
    }

    renderCRV() {
      const CRVOptions = this.getCRVOptions();
      return (
        <Field
          name="CRV_id"
          component={Selection}
          withRef
          ref="CRVOptions"
          options={CRVOptions}
          onKeyPress={(event) => {
            if (event.keyCode == 13) { ReactDOM.findDOMNode(this.refs.ProductBarcode.getRenderedComponent().myInput.refs.input).focus(); }
        }}
        />
      );
    }

    getCRVOptions() {
      const CRVOptions = [];
      this.props.CRVs.map((CRV) => {
        CRVOptions.push({ value: CRV.Product_id, label: CRV.Name });
      });
      return CRVOptions;
    }

    // renderDefaultBinRange() {
    //   return (
    //       <FieldArray name="BinRangeList" component={renderBinRangeList} />
    //   )
    // }

    renderConvertDetails() {
      return (
        <FieldArray name="Related_Products" component={renderConvertDetailsList} />
      );
    }

    handleFormSubmit(formProps) {
      this.props.editProduct(formProps, this.state, true);
      this.props.quickAdjustment(this.props.currentInventoryDetail, this.state.editedRows);
    }

    renderZone() {
      if (this.props.zoneIsLoading) return <Spinner />; // If group is loading, show a spinner.

      const zoneOptions = this.getZoneOptions();
      return (
        <Row>
          <Field
            name="Default_WarehouseZone_id"
            component={SelectionWithProps}
            options={zoneOptions}
            onChange={this.handleZoneOnChange}
          />
        </Row>
      );
    }

    renderDefaultBinRange() {
      if (this.props.binIsLoading) {
        return <Spinner />;
      } // If group is loading, show a spinner.
      const binOptions = this.getBinOptions();
      const levelOptions = [
        { value: 'FL', label: 'FL' },
        { value: 'A', label: 'A' },
        { value: 'B', label: 'B' },
        { value: 'C', label: 'C' },
      ];
      return (
        <FieldArray
          name="BinRangeList"
          component={renderBinRangeList}
          binOptions={binOptions}
          levelOptions={levelOptions}
        />
      );
    }

    renderTableFilter() {
      const daysSelection = [
        {
          label: `7 ${I18n.t('days')}`,
          value: '7',
        },
        {
          label: `30 ${I18n.t('days')}`,
          value: '30',
        },
        {
          label: `90 ${I18n.t('days')}`,
          value: '90',
        },
      ]

      const handleClick = (el) => {
        this.setState({
          activeTransactionType: el.value,
          activeTransactionTypeInTitle: el.label,
        }, () => {
          this.props.updateReceiveTableFilter({transaction: this.state.activeTransactionType})
        })
      }

      const handleDaysClick = (el) => {
        this.setState({
          receiveDays: el
        })
        var date = new Date();
        var last = new Date(date.getTime() - (el.value * 24 * 60 * 60 * 1000));
        const newDate = {
          start_date: last,
          end_date: date,
        }
        this.setState({
          ReceiveFromDate: last,
          ReceiveToDate: date,
        })
        this.props.updateReceiveTableFilter({ ...newDate });
      }

      return (
        <div style={{ width: '100%' }}>
          <ButtonToolbar className="table-buttons" style={{ marginLeft: '8px' }}>
              {/* <Col xs={4}>
                {this.generateDropdownSelections(filterTypeOptions, handleClick, this.state.activeTransactionTypeInTitle)}
              </Col> */}
              <Col xs={4}>
                {this.generateDaysDropdownSelection(daysSelection, this.state.receiveDays, handleDaysClick )}
              </Col>
              <Col xs={4}>
                <DateTimePicker
                  id="from-datepicker"
                  format="MM-DD-YY"
                  onChange={(e) => {
                      if (this.state.ReceiveToDate && e > this.state.ReceiveToDate) {
                        return;
                      }
                      this.setState({ ReceiveFromDate: e },
                        () => {
                          this.props.updateReceiveTableFilter({ start_date: this.state.ReceiveFromDate })
                        }
                      );
                    }}
                  // max={this.state.ToDate}
                  time={false}
                  placeholder="Start"
                  value={this.state.ReceiveFromDate}
                />
              </Col>
              <Col xs={4}>
                <DateTimePicker
                  id="to-datepicker"
                  format="MM-DD-YY"
                  onChange={(e) => {
                      if (e < this.state.ReceiveFromDate) {
                        return;
                      }
                      this.setState({ ReceiveToDate: e },
                        () => {
                          this.props.updateReceiveTableFilter({ end_date: this.state.ReceiveToDate })
                        }
                      );
                    }}
                  min={this.state.ReceiveFromDate}
                  time={false}
                  placeholder="End"
                  value={this.state.ReceiveToDate}
                />
              </Col>
          </ButtonToolbar>
          <p style={{ float: 'right', display: 'inline-block', color: 'red' }}>
            <Translate value='total_inventory_worth' />:  $
            {
              this.state.total_worth
            }
          </p>
        </div>)

    }

    renderTable() {
      const that = this;
      if (this.props.detailIsLoading && !this.props.error) return <Spinner />;
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{this.props.error}</div></ContentWrapper>;


      // Parameters of the react-data-grid

      const getRows = () => Data.Selectors.getRows(this.state.history);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return Object.assign({}, rows[rowIdx]);
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        var state = Object.assign({}, this.state.history, { sortColumn: sortColumn, sortDirection: sortDirection });
        this.setState({history:state});
        // const comparer = function (a, b) {
        //   if (sortDirection === 'ASC') {
        //     return (a[sortColumn] > b[sortColumn]) ? 1 : -1;
        //   } else if (sortDirection === 'DESC') {
        //     return (a[sortColumn] < b[sortColumn]) ? 1 : -1;
        //   }
        // };
        // const comparerBin = function (a, b) {
        //   if (sortDirection === 'ASC') {
        //     return (a[sortColumn].Name > b[sortColumn].Name) ? 1 : -1;
        //   } else if (sortDirection === 'DESC') {
        //     return (a[sortColumn].Name < b[sortColumn].Name) ? 1 : -1;
        //   }
        // };

        // if (sortColumn == 'WarehouseBin_id') { var rows = sortDirection === 'NONE' ? this.state.rows : this.state.rows.sort(comparerBin); } else { var rows = sortDirection === 'NONE' ? this.state.rows : this.state.rows.sort(comparer); }
        // this.setState({ rows });
      };

      const onClearFilters = () => {
        // all filters removed
        const history = { ...this.state.history, filters: {} };
        this.setState({ history });
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.history.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        this.setState({ history: {
          ...this.state.history,
          filters: newFilters
        }});
      };

      const handleRowUpdated = (e) => {
        const rows = getRows();
        // let rows = this.state.rows;
        Object.assign(rows[e.rowIdx], e.updated);
        const editedRows = this.state.editedRows.slice(0);
        // if the element is already edited, remove the old one.
        editedRows.forEach((element, index) => {
          if (element.id === rows[e.rowIdx].id) { editedRows.splice(index, 1); }
        }, this);
        // push the row into the editedRows array
        editedRows.push(rows[e.rowIdx]);
        this.setState({
          rows,
          editedRows,
        });
      };

      const BinFormatter = React.createClass({
        render() {
          if (this.props.value) return <span style={{ color: this.props.value.Description }}>{this.props.value.Name}</span>;
          return <span className="label label-danger">-</span>;
        },
      });

      const batchFormatter = React.createClass({
        render() {
          return <span>{this.props.dependentValues}</span>
        }
      })

      const batchQuantityFormatter = React.createClass({
        render() {
          return <span style={{ color: 'red' }}>{this.props.dependentValues}</span>
        }
      })
      const UTCtimeFormatter = React.createClass({
        render() {
          const d = new Date(this.props.value);
          return <span>{d.toString().split('GMT')[0]}</span>
        }
      })

      const DateFormatte = React.createClass({
        render() {
          if (this.props.value) {
            const dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const date = new Date(this.props.value);
            const index = dateMap.indexOf(date.toString().slice(4, 3));
            const localDate = index + date.toString().slice(8, 6);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });

      const WeightFormatter = React.createClass({
        render() {
          if (that.state.productType && that.state.productType !== 'Fixed') {
            return <span>{this.props.value}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });


      // Column difinition

      const columns = [
        {
          key: 'PONum',
          name: <Translate value="po_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        },
        {
          key: 'batch_num',
          name: <Translate value="batch_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: batchFormatter,
          getRowMetaData: row => row.batch ? row.batch.batch_num : '',
        },
        {
          key: 'orderQuantity',
          name: <Translate value="po_quantity" />,
          resizable: true,
          sortable: true,
          filterable: true,
          // editable: this.state.enableAdjustment,
          width: 100,
        },
        {
          key: 'quantity',
          name: <Translate value="receive_quantity" />,
          resizable: true,
          sortable: true,
          filterable: true,
          // formatter: WeightFormatter,
          // editable: this.state.enableAdjustment,
          width: 100,
        },
        {
          key: 'batch_quantity',
          name: <Translate value="batch_quantity" />,
          resizable: true,
          sortable: true,
          filterable: true,
          formatter: batchQuantityFormatter,
          // editable: this.state.enableAdjustment,
          width: 100,
          getRowMetaData: row => row.batch ? row.batch.quantity : '',
        },
        // {
        //   key: 'Weights',
        //   name: <Translate value="total_wt" />,
        //   resizable: true,
        //   sortable: true,
        //   filterable: true,
        //   formatter: WeightFormatter,
        //   editable: this.state.enableAdjustment,
        //   width: 90,
        // },
        {
          key: 'unit_price',
          name: <Translate value="unit_price" />,
          resizable: true,
          sortable: true,
          filterable: true,
          formatter: batchFormatter,
          width: 100,
          getRowMetaData: row => row.batch ? row.batch.unit_price : row.unit_price,
        },
        {
          key: 'weight',
          name: <Translate value="weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          formatter: batchFormatter,
          width: 80,
          getRowMetaData: row => row.batch ? row.batch.weight : row.unit_net_weight,
        },
        {
          key: 'vendorName',
          name: <Translate value="vendor" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 180,
        },
        ...isGGI ? [
          {
            key: 'container_num',
            name: <Translate value="container_no" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 130,
          },
          {
            key: 'ETA_datetime',
            name: <Translate value="eta_date" />,
            resizable: true,
            sortable: true,
            filterable: true,
            formatter: DateFormatter,
            width: 170,
          }
        ]:[],
        {
          key: 'receiveDate',
          name: <Translate value="receiveDate" />,
          resizable: true,
          sortable: true,
          filterable: true,
          formatter: UTCtimeFormatter,
          // editable: this.state.enableAdjustment,
          width: 170,
        },
        {
          key: 'expire_datetime',
          name: <Translate value="expire_datetime" />,
          resizable: true,
          sortable: true,
          filterable: true,
          formatter: batchFormatter,
          width: 170,
          getRowMetaData: row => row.batch ? row.batch.expire_datetime : '',
        }
      ];

      if(isGGI) {
        _.findIndex(columns, )
        const companyLayout = {
          key: 'company',
          name: <Translate value="company" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        };
        const warehouseLayout = {
          key: 'warehouse',
          name: <Translate value="warehouse" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
        }
        columns.push(companyLayout);
        columns.push(warehouseLayout);
      }

      return (
      // React Table Product Order History
        <Row style={{ marginTop: '40px' }}>
          <Col xs={12}>
            <div id="InventoryDetail-dataGrid1">
              <ReactDataGrid
                rowKey="id"
                rowRenderer={
                  <RowRenderer />
                }
                onGridSort={handleGridSort}
                // toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                onClearFilters={onClearFilters}
                columns={columns}
                headerRowHeight={45}
                rowHeight={25}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                enableCellSelect
                onRowUpdated={handleRowUpdated}
                minHeight={250}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderProductsTable() {
      const that = this;

      // Parameters of the react-data-grid

      const tableHeight = (window.innerHeight < 930) ? 250 : 250;

      const getRows = () => Data.Selectors.getRows(this.state.inventoryAdjustment);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const state = Object.assign({}, this.state.inventoryAdjustment, { sortColumn, sortDirection });
        this.setState({ inventoryAdjustment: state });
      };

      const onClearFilters = () => {
        // all filters removed
        const inventoryAdjustment = { ...this.state.inventoryAdjustment, filters: {} };
        this.setState({ inventoryAdjustment });
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.inventoryAdjustment.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const inventoryAdjustment = { ...this.state.inventoryAdjustment, filters: newFilters };
        this.setState({ inventoryAdjustment });
      };

      // Handle the row select function

      const onRowSelect = (rows) => {
        const inventoryAdjustment = { ...this.state.inventoryAdjustment, selectedRows: rows };
        this.setState({ inventoryAdjustment });
      };

      // Custom Formatter component

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            const dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const date = new Date(this.props.value);
            const index = dateMap.indexOf(date.toString().slice(4, 3));
            const localDate = index + date.toString().slice(8, 6);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });

      const WeightFormatter = React.createClass({
        render() {
          if (that.state.productType !== 'Fixed') {
            return <span>{this.props.value}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });

      const nestedDataFormatter = React.createClass({
        render() {
          return <span>{this.props.dependentValues}</span>
        }
      })

      const UTCtimeFormatter = React.createClass({
        render() {
          const d = new Date(this.props.dependentValues);
          return <span>{d.toString().split('GMT')[0]}</span>
        }
      })
      // Column definition

      // const columns = [
      //   {
      //     key: 'Num',
      //     name: <Translate value="num" />,
      //     resizable: true,
      //     sortable: true,
      //     filterable: true,
      //     width: 105,
      //   },
      //   {
      //     key: 'Date',
      //     name: <Translate value="date" />,
      //     resizable: true,
      //     sortable: true,
      //     filterable: true,
      //     formatter: DateFormatter,
      //     width: 100,
      //   },
      //   {
      //     key: 'Type',
      //     name: <Translate value="type" />,
      //     resizable: true,
      //     sortable: true,
      //     filterable: true,
      //     width: 130,
      //   },
      //   {
      //     key: 'Operator',
      //     name: <Translate value="operator" />,
      //     resizable: true,
      //     sortable: true,
      //     width: 100,
      //   },
      //   {
      //     key: 'Vendor',
      //     name: <Translate value="vendor_name" />,
      //     resizable: true,
      //     sortable: true,
      //     filterable: true,
      //     width: 135,
      //   },
      //   {
      //     key: 'Quantity',
      //     name: <Translate value="qty" />,
      //     resizable: true,
      //     width: 40,
      //     sortable: true,
      //   },
      //   {
      //     key: 'TotalNetWeight',
      //     name: <Translate value="total_wt" />,
      //     resizable: true,
      //     sortable: true,
      //     filterable: true,
      //     formatter: WeightFormatter,
      //     width: 90,
      //   },
      //   {
      //     key: 'UnitPrice',
      //     name: <Translate value="unit_dollarsign" />,
      //     resizable: true,
      //     sortable: true,
      //     filterable: true,
      //     formatter: CashFormatter,
      //     width: 85,
      //   },
      // ];
      const columns = [
        {
          key: 'SONumber',
          name: <Translate value="so_number" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 150,
          formatter: nestedDataFormatter,
          getRowMetaData: row => row.SalesOrder ? row.SalesOrder.SONum : '',
        },
        {
          key: 'orderDate',
          name: <Translate value="order_date" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 165,
          formatter: UTCtimeFormatter,
          getRowMetaData: row => row.SalesOrder ? row.SalesOrder.OrderDate : '',
        },
        {
          key: 'invoice_number',
          name: <Translate value="invoice_number" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: nestedDataFormatter,
          getRowMetaData: row => row.SalesInvoice ? row.SalesInvoice.InvoiceNum : '',
        },
        {
          key: 'product_name',
          name: <Translate value="product_name" />,
          resizable: true,
          sortable: true,
          width: 150,
          filterable: true,
          formatter: nestedDataFormatter,
          getRowMetaData: row => row.Product ? row.Product.Name : '',
        },
        {
          key: 'product_number',
          name: <Translate value="product_number" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: nestedDataFormatter,
          getRowMetaData: row => row.Product ? row.Product.ProductNum : '',
        },
        {
          key: 'customer_name',
          name: <Translate value="customer_name" />,
          resizable: true,
          width: 100,
          sortable: true,
          filterable: true,
          formatter: nestedDataFormatter,
          getRowMetaData: row => row.DeliverCustomer ? row.DeliverCustomer.Name : '',
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_price" />,
          resizable: true,
          sortable: true,
          filterable: true,
          // formatter: WeightFormatter,
          width: 90,
        },
        {
          key: 'Quantity',
          name: (isLAP || isAPD)?<Translate value="order_qty" />:<Translate value="quantity" />,
          resizable: true,
          sortable: true,
          filterable: true,
          // formatter: CashFormatter,
          width: 85,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_price" />,
          resizable: true,
          sortable: true,
          filterable: true,
          // formatter: CashFormatter,
          width: 85,
        },
        {
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          filterable: true,
          // formatter: CashFormatter,
          width: 85,
        },
      ];

      if ((isLAP || isAPD) || isGGI || isOLG || isVAK) {
        const shipIndex = _.findIndex(columns, { key: 'Quantity' });
        const shippedQty = {
          key: 'LoadedQuantity',
          name: <Translate value="shipped_qty" />,
          resizable: true,
          sortable: true,
          width: 80,
          // formatter: CashFormatter,
        };

        columns.splice(shipIndex +1 , 0, shippedQty);
      }
      if(isGGI) {
        let vendorNameIdx = _.findIndex(columns, {key:'CostPrice'})
        _.findIndex(columns, )
        const companyLayout = {
          key: 'company',
          name: <Translate value="company" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        };
        const warehouseLayout = {
          key: 'warehouse',
          name: <Translate value="warehouse" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
        }
        columns.splice(vendorNameIdx, 1, companyLayout, warehouseLayout);
      }

      // React Table Purchase Order Details
      return (
        <Row style={{ marginTop: '40px' }}>
          <Col xs={12}>
            <div className="recat-customizer" id="InventoryDetail-dataGrid2">
              <ReactDataGrid
                rowKey="historyId"
                onGridSort={handleGridSort}
                rowRenderer={<RowSalesHisRenderer />}
                // toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                onClearFilters={onClearFilters}
                columns={columns}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                rowHeight={25}
                minHeight={tableHeight}
                onRowUpdated={this.handleRowUpdated}
                // onRowSelect={onRowSelect}
                // enableCellSelect
              />
            </div>
          </Col>
        </Row>
      );
    }

    generateDropdownSelections = (filterTypeOptions, handleClick, title) => {
      return(
      //   <DropdownButton
      //   bsStyle={'default'}
      //   title={'transaction type'}
      //   onSelect={onSelect}
      // >
      //     {filterTypeOptions.map(el => {
      //       return (
      //         <MenuItem eventKey="1" active={this.state.activeTransactionType} onClick={handleClick}>Action</MenuItem>

      //       )
      //     })}
      //     <MenuItem eventKey="1">Action</MenuItem>
      //     <MenuItem eventKey="2">Another action</MenuItem>
      //     <MenuItem eventKey="3" active={this.state.activeTransactionType}>
      //       Active Item
      //     </MenuItem>
      //   </DropdownButton>
      <Dropdown id="dropdown-custom-1">
        <Dropdown.Toggle>
          {title}
        </Dropdown.Toggle>
        <Dropdown.Menu className="super-colors">
          {filterTypeOptions.map(el => {
            return (
              <MenuItem onClick={() => handleClick(el)}>{el.label}</MenuItem>
              )
          })}
      </Dropdown.Menu>
    </Dropdown>
      )
    }

    generateDaysDropdownSelection = (daysSelection, currentSelected, handleDaysClick) => (
      <Dropdown id="dropdown-custom-1">
        <Dropdown.Toggle>
          {currentSelected.label}
        </Dropdown.Toggle>
        <Dropdown.Menu className="super-colors">
          {daysSelection.map(el => {
            return (
              <MenuItem onClick={() => handleDaysClick(el)}>{el.label}</MenuItem>
              )
          })}
        </Dropdown.Menu>
      </Dropdown>
    )

    calculateSalesMargin = (totalWorth, totalPrice) => {
      return (100 * (totalPrice/totalWorth)).toFixed(2)
    }

    renderToolbarFilter = () => {

      const filterTypeOptions = [{
        label: 'All Transactions',
        value: 'all',
      }, {
        label: 'Received',
        value: 'received',
      }, {
        label: 'Sales',
        value: 'sales',
      }, {
        label: 'Converted',
        value: 'converted',
      }, {
        label: 'Adjustments',
        value: 'adjustment',
      }];

      const daysSelection = [
        {
          label: `7 ${I18n.t('days')}`,
          value: '7',
        },
        {
          label: `30 ${I18n.t('days')}`,
          value: '30',
        },
        {
          label: `90 ${I18n.t('days')}`,
          value: '90',
        },
      ]

      const handleClick = (el) => {
        this.setState({
          activeTransactionType: el.value,
          activeTransactionTypeInTitle: el.label,
        }, () => {
          this.props.updateFilter({transaction: this.state.activeTransactionType})
        })
      }

      const handleDaysClick = (el) => {
        this.setState({
          days: el
        }, () => { console.log('el', el)})
        var date = new Date();
        var last = new Date(date.getTime() - (el.value * 24 * 60 * 60 * 1000));
        const newDate = {
          end_date: date,
          start_date: last,
        }
        this.setState({
          FromDate: last,
          ToDate: date,
        })
        this.props.updateFilter({ ...newDate })
      }

      const handleOnSelect = () => {
        this.props.updateFilter({transaction: this.state.activeTransactionType})
      }

      return (
        <div style={{ width: '100%' }}>
          <ButtonToolbar className="table-buttons">
              {/* <Col xs={4}>
                {this.generateDropdownSelections(filterTypeOptions, handleClick, this.state.activeTransactionTypeInTitle)}
              </Col> */}
              <Col xs={4}>
                {this.generateDaysDropdownSelection(daysSelection, this.state.days, handleDaysClick )}
              </Col>
              <Col xs={3}>
                <DateTimePicker
                  id="from-datepicker"
                  format="MM-DD-YY"
                  onChange={(e) => {
                      if (this.state.ToDate && e > this.state.ToDate) {
                        return;
                      }
                      this.setState({ FromDate: e },
                        () => {
                          this.props.updateFilter({ start_date: this.state.FromDate })
                        }
                      );
                    }}
                  // max={this.state.ToDate}
                  time={false}
                  placeholder="Start"
                  value={this.state.FromDate}
                />
              </Col>
              <Col xs={4}>
                <DateTimePicker
                  id="to-datepicker"
                  format="MM-DD-YY"
                  onChange={(e) => {
                      if (e < this.state.FromDate) {
                        return;
                      }
                      this.setState({ ToDate: e },
                        () => {
                          this.props.updateFilter({ end_date: this.state.ToDate })
                        }
                      );
                    }}
                  min={this.state.FromDate}
                  time={false}
                  placeholder="End"
                  value={this.state.ToDate}
                />
              </Col>
          </ButtonToolbar>
          <p style={{ float: 'right', color: 'red', display: 'inline-block', marginLeft: '20px' }}>
            <Translate value='total_sales_worth' />:  $
            {
              this.state.total_price
            }
          </p>
          <p style={{ float: 'right', color: 'red', display: 'inline-block' }}>
            <Translate value='sales_inventory_value' />:
            {
              this.calculateSalesMargin(this.state.total_worth, this.state.total_price)
            }%
          </p>
        </div>)
    }
    goToRoute = (route) => {
      this.context.router.push(route)
    }
    goToWorkingOrder = () => {
      window.location.pathname = 'workingOrders'
    }
    render() {
      const costsDetailsPanelHeader = (<h2><Translate value="costs_details" /></h2>);
      const saleDetailsPanelHeader = (<h2><Translate value="sale_details" /></h2>);
      const inventoryDetailsPanelHeader = (<h2><Translate value="inventory_details" /></h2>);
      const priceLevelPanelHeader = (<h2><Translate value="price_levels" /></h2>);
      const {
        handleSubmit, invalid, submitting, pristine,
      } = this.props;
      const imageFile = this.props.currentProductDetail && this.props.currentProductDetail.Thumbnail;
      const createDialogStyle = {
        width: '550px',
        height: '300px',
        marginLeft: '-15%',
      };
      if (this.props.inventoryIsLoading && !this.props.inventoryError) return <Spinner />;
      else if (this.props.inventoryError) return <ContentWrapper><div className="alert alert-danger">{this.props.inventoryError.message}</div></ContentWrapper>;

      return (
      //---------------
      // Begin HTML
      //---------------
        <ContentWrapper>
          <form className="form-horizontal" method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))} >
            {/* Nav Trail */}
            <Breadcrumb>
              <Breadcrumb.Item>
                <Translate value="warehouse_management" />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Translate value="inventory" />
              </Breadcrumb.Item>
              <Breadcrumb.Item active="true">
                <Translate value="inventory_detail" />
              </Breadcrumb.Item>
            </Breadcrumb> {/* End Nav Trail */}
            {/* Button Actions */}
            <ButtonToolbar>
              {/* <Button
                onClick={this.openAdjustment}
              >
                <Translate value="inventory_adjustment" />
              </Button>
              <Button
                bsStyle="success"
                type="button"
                onClick={handleSubmit(this.handleFormSubmit.bind(this))}
                disabled={!checkPermission('change_warehouse_adjustment')}
              >
                <em className="fa fa-save" /> <Translate value="save" />
              </Button> */}
              <Button
                bsStyle="primary"
                type="reset"
                onClick={this.goToWorkingOrder}
              >
                <Translate value="working_order" />
              </Button>
              <Button
                bsStyle="primary"
                type="reset"
                onClick={() => this.goToRoute('inventoryReturn')}
              >
                <Translate value="sales_return" />
              </Button>
              <Button
                bsStyle="primary"
                type="reset"
                onClick={() => this.goToRoute('purchaseReturn')}
              >
                <Translate value="purchase_return" />
              </Button>
              <Button
                bsStyle="danger"
                type="reset"
                onClick={browserHistory.goBack}
              >
                <em className="fa fa-close" /> <Translate value="cancel" />
              </Button>
            </ButtonToolbar> {/* End Button Actions */}

            <Grid id="inventory-details-page">
              {/* Row Wrapper */}
              <Row>
                <Col xs={12}>
                  <h1>{this.props.currentProductDetail && this.props.currentProductDetail.Name}{' '}{this.props.currentProductDetail && this.props.currentProductDetail.Description}</h1>
                  {/* Product Information Panel */}
                  <Row>
                    <Col xs={12}>
                      <Panel id="product-info-panel">
                              <Row>
                                <Col xs={2}>
                                  <div className="form-group">
                                    <label className="col-xs-4"><Translate value="prod_num" /><span className="colon">:</span></label>
                                    <div className="col-xs-8">
                                      <Field component={DisabledInputField} placeholder={this.state.productNum} />
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={2}>
                                  <div className="form-group">
                                    <label className="col-xs-4"><Translate value={isOLG ? "item_no" : "ref_num"} /><span className="colon">:</span></label>
                                    <div className="col-xs-8">
                                      <Field component={DisabledInputField} placeholder={this.state.refNum} />
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={2}>
                                  <div className="form-group">
                                    <label className="col-xs-4"><Translate value="instock" /><span className="colon">:</span></label>
                                    <div className="col-xs-8">
                                      <Field component={DisabledInputField} placeholder={this.state.inStock} />
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={2}>
                                  <div className="form-group">
                                    <label className="col-xs-4"><Translate value="presale" /><span className="colon">:</span></label>
                                    <div className="col-xs-8">
                                      <Field component={DisabledInputField} placeholder={this.state.PreSale} />
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={2}>
                                  <div className="form-group">
                                    <label className="col-xs-3"><Translate value="purchased" /><span className="colon">:</span></label>
                                    <div className="col-xs-8 col-xs-offset-1">
                                      <Field component={DisabledInputField} placeholder={this.state.purchased} />
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={2}>
                                  <div className="form-group">
                                    <label className="col-xs-4"><Translate value="total_weight" /><span className="colon">:</span></label>
                                    <div className="col-xs-8">
                                      <Field component={DisabledInputField} placeholder={this.state.TotalWeight} />
                                    </div>
                                  </div>
                                </Col>
                                {
                                  isSV &&
                                  <Col xs={2}>
                                  <div className="form-group">
                                    <label className="col-xs-6"><Translate value="available_qty" /><span className="colon">:</span></label>
                                    <div className="col-xs-6">
                                      <Field component={DisabledInputField} placeholder={this.state.available} />
                                    </div>
                                  </div>
                                </Col>
                                }
                              </Row>
                            </Panel>
                    </Col>
                  </Row> {/* Product Information Panel */}

                  {/* Detail Panels */}
                  {/* <Row> */}
                  {/* Sale Details */}
                  {/* <Col xs={ 4 }>
                            <Row>
                              <Col xs={ 12 }>
                                <Panel id="sale-details" header={saleDetailsPanelHeader}>
                                  <Row>
                                    <Col xs={ 12 }>
                                      <div className="thumbnail">
                                        <span className="fa fa-arrow-circle-left btn-lg"></span>
                                        <img src={imageFile} alt="Product image" />
                                        <span className="fa fa-arrow-circle-right btn-lg"></span>
                                      </div>
                                    </Col>
                                  </Row>
                                  <div className="form-horizontal sale-radios">
                                    <Field name="IsStopSale" component={renderSaleRadios}  />
                                  </div>
                                </Panel>
                              </Col>
                            </Row>
                          </Col>  */}
                  {/* End Sale Details */}

                  {/* Cost Details */}
                  {/* <Col xs={ 4 }>
                            <Row>
                              <Col xs={ 12 }>
                                  <Panel id="cost-details" header={costsDetailsPanelHeader}>
                                   <Row>
                                    {this.renderAvgCost()}
                                    <Col xs={ 6 } className="ref-cost-col">
                                      <div className="form-group">
                                        <label className="col-xs-6"><Translate value="ref_cost" /></label>
                                        <div className="col-xs-6">
                                          <Field name="RefPrice" withRef={true} ref="RefPrice" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                              this.handleKeyPress('LowestSalePrice', event)
                                          }}/>
                                        </div>
                                      </div>
                                      <div className="form-group">
                                        <label className="col-xs-6 text-nowrap"><Translate value="lowest_sale_dollarsign" /></label>
                                        <div className="col-xs-6">
                                          <Field name="LowestSalePrice" withRef={true} ref="LowestSalePrice" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                                this.handleKeyPress('LV1', event)
                                            }}/>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row> */}

                  {/* original zone and bin range */}
                  { /* <h3><Translate value="location" /> / <Translate value="bin_range" /></h3>

                                  <Row>
                                    <Col xs={ 6 }>
                                      <div className="form-group">
                                        <label className="col-xs-3"><Translate value="zone" /></label>
                                        <div className="col-xs-9">
                                          { this.renderZone() }
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs={ 6 }>
                                      <div className="form-group">
                                        <label className="col-xs-4 mr-lg"><Translate value="shelf_life" /></label>
                                        <div className="col-xs-5">
                                          <Field name="ShiftLife" withRef={true} ref="ShelfLife" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                              if (event.charCode == 13)
                                                event.preventDefault();
                                          }}/>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    {this.renderDefaultBinRange()}
                                  </Row>
                                  */ }
                  {/* end original zone and bin range */}

                  {/* <h3><Translate value="price_level_setup" /></h3>
                                   */}
                  {/* Per Michael: Do not include for demo
                                  <Row>
                                    <Col xs={ 12 } className="centerStyle">
                                      <Field name="RoundPriceLevels" labelName="is_two_decimal" component={ renderRadios } />
                                    </Col>
                                  </Row> */}

                  {/* <h3><Translate value="location" /> / <Translate value="bin_range" /></h3>
                                  <Row>
                                    <Col xs={4}>
                                      <div className="form-group">
                                        <label className="col-xs-4"><Translate value="zone" /></label>
                                        <div className="col-xs-8">
                                          <Field
                                            name='Zone'
                                            ref='Zone'
                                            withRef
                                            onFocus={this.handleOnFocus}
                                            component={InputField}
                                            onKeyPress={(event) => {
                                                this.handleKeyPress('Bin', event)
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs={4}>
                                      <div className="form-group">
                                        <label className="col-xs-4"><Translate value="bin" /></label>
                                        <div className="col-xs-8">
                                        <Field
                                          name='Bin'
                                          ref='Bin'
                                          withRef
                                          onFocus={this.handleOnFocus}
                                          component={InputField}
                                          onKeyPress={(event) => {
                                              this.handleKeyPress('Level', event)
                                          }}
                                        />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs={4}>
                                      <div className="form-group">
                                        <label className="col-xs-4"><Translate value="level" /></label>
                                        <div className="col-xs-8">
                                          <Field
                                            name='Level'
                                            ref='Level'
                                            withRef
                                            onFocus={this.handleOnFocus}
                                            component={InputField}
                                            onKeyPress={(event) => {
                                                this.handleKeyPress('ShelfLife', event)
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs={4}>
                                      <div className="form-group">
                                        <label className="col-xs-6"><Translate value="shelf_life" /></label>
                                        <div className="col-xs-6">
                                          <Field name="ShiftLife" withRef={true} ref="ShelfLife" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                              if (event.charCode == 13)
                                                event.preventDefault();
                                          }}/>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Panel>
                              </Col>
                            </Row>
                          </Col>  */}
                  {/* End Cost Details Column */}

                  {/* Convert Details */}
                  {/* <Col xs={ 4 }>
                            <Row>
                              <Col xs={ 12 }>
                                <Panel id="price-levels" header={priceLevelPanelHeader}>
                                  <Row>
                                    <Col xs={ 12 }>
                                      <Row>
                                        <Col xs={ 12 }>
                                          <Field name="ConvertType" component={ convertNumRadios } />
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col xs={ 12 }>
                                          <div className="form-group border-bottom">
                                            <label className="col-xs-4"><Translate value="cvrt_prod_qty" /></label>
                                            <div className="col-xs-8">
                                              <Field name="ConvertNum" component={ DisabledInputField } />
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row> */}{/* End Convert Radios */}

                  {/* Prod No & Qty Label / Input Group */}
                  {/* <Row>
                                    {this.renderConvertDetails()}
                                  </Row>  */}
                  {/* End Prod No & Qty Label / Input Group */}

                  {/* Price Level Setup */}
                  {/* <Row>
                                    <Col xs={ 12 } className="centerStyle price-level-setup">
                                      <Row>
                                        <Col xs={ 4 }>
                                          <div className="form-group">
                                              <label className="col-xs-4"><Translate value="lv_1" /> %</label>
                                              <div className="col-xs-7">
                                              <Field name="P1Percentage" className="control-label" component={ ControlledInputField } onFocus={this.handleOnFocus} withRef={true} ref="LV1" placeholder={this.state.p1Percentage} onChange={(event) => {this.handlePercentageChange("p1Percentage", event)}} onKeyPress={(event) => {
                                                    this.handleKeyPress('LV2', event)
                                                }}/>
                                            </div>
                                          </div>
                                          <span className="equal-sign">=</span>
                                        </Col>
                                        <Col xs={ 4 }>
                                          <div className="form-group">
                                            <label className="col-xs-4"><Translate value="lv_1" /><span className="dollar-sign">$</span></label>
                                            <div className="col-xs-7">
                                              <Field name="PriceLv1" className="control-label" component={ ControlledInputField } onFocus={this.handleOnFocus} withRef={true} ref="LV1_2" placeholder={this.state.priceLv1.toFixed(2) || 0} onChange={(event) => {this.handlePriceChange("priceLv1", event)}} onKeyPress={(event) => {
                                                    this.handleKeyPress('LV2_2', event)
                                                }}/>
                                            </div>
                                          </div>
                                        </Col>
                                        <Col xs={ 4 } className="pull-right">
                                          <div className="form-group">
                                            <label className="col-xs-4"><Translate value="lv_1" /><span className="dollar-sign">$</span></label>
                                            <div className="col-xs-8">
                                              <Field name="PriceLv1Rounded" className="control-label" component={ DisabledInputField } placeholder={this.roundUp(this.state.priceLv1)} />
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs={ 12 } className="centerStyle">
                                      <Row>
                                        <Col xs={ 4 }>
                                          <div className="form-group">
                                            <label className="col-xs-4"><Translate value="lv_2" /> %</label>
                                            <div className="col-xs-7">
                                              <Field name="P2Percentage" className="control-label" component={ ControlledInputField } onFocus={this.handleOnFocus} withRef={true} ref="LV2" placeholder={this.state.p2Percentage} onChange={(event) => {this.handlePercentageChange("p2Percentage", event)}} onKeyPress={(event) => {
                                                    this.handleKeyPress('LV3', event)
                                                }}/>
                                            </div>
                                          </div>
                                          <span className="equal-sign">=</span>
                                        </Col>
                                        <Col xs={ 4 }>
                                          <div className="form-group">
                                            <label className="col-xs-4"><Translate value="lv_2" /><span className="dollar-sign">$</span></label>
                                            <div className="col-xs-7">
                                              <Field name="PriceLv2" className="control-label" component={ ControlledInputField } onFocus={this.handleOnFocus} withRef={true} ref="LV2_2" placeholder={this.state.priceLv2.toFixed(2) || 0} onChange={(event) => {this.handlePriceChange("priceLv2", event)}} onKeyPress={(event) => {
                                                    this.handleKeyPress('LV3_2', event)
                                                }}/>
                                            </div>
                                          </div>
                                        </Col>
                                        <Col xs={ 4 }>
                                          <div className="form-group">
                                            <label className="col-md-4"><Translate value="lv_2" /><span className="dollar-sign">$</span></label>
                                            <div className="col-md-8">
                                              <Field name="PriceLv1Rounded" className="control-label" component={ DisabledInputField } placeholder={this.roundUp(this.state.priceLv2)} />
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs={ 12 } className="centerStyle">
                                      <Row>
                                        <Col xs={ 4 } className="level-col-percentages">
                                          <div className="form-group">
                                            <label className="col-xs-4"><Translate value="lv_3" /> %</label>
                                            <div className="col-xs-7">
                                              <Field name="P3Percentage" className="control-label" component={ ControlledInputField } onFocus={this.handleOnFocus} withRef={true} ref="LV3" placeholder={this.state.p3Percentage} onChange={(event) => {this.handlePercentageChange("p3Percentage", event)}} onKeyPress={(event) => {
                                                    this.handleKeyPress('LV4', event)
                                                }}/>
                                            </div>
                                          </div>
                                          <span className="equal-sign">=</span>
                                        </Col>
                                        <Col xs={ 4 } className="level-col-dollar">
                                          <div className="form-group">
                                            <label className="col-xs-4"><Translate value="lv_3" /><span className="dollar-sign">$</span></label>
                                            <div className="col-xs-7">
                                              <Field name="PriceLv3" className="control-label" component={ ControlledInputField } onFocus={this.handleOnFocus} withRef={true} ref="LV3_2" placeholder={this.state.priceLv3.toFixed(2) || 0} onChange={(event) => {this.handlePriceChange("priceLv3", event)}} onKeyPress={(event) => {
                                                    this.handleKeyPress('LV4_2', event)
                                                }}/>
                                            </div>
                                          </div>
                                        </Col>
                                        <Col xs={ 4 }>
                                          <div className="form-group">
                                            <label className="col-md-4"><Translate value="lv_3" /><span className="dollar-sign">$</span></label>
                                            <div className="col-md-8">
                                              <Field name="PriceLv1Rounded" className="control-label" component={ DisabledInputField } placeholder={this.roundUp(this.state.priceLv3)} />
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs={ 12 } className="centerStyle">
                                      <Row>
                                        <Col xs={ 4 }>
                                          <div className="form-group">
                                            <label className="col-xs-4"><Translate value="lv_4" /> %</label>
                                            <div className="col-xs-7">
                                              <Field name="P4Percentage" className="control-label" component={ ControlledInputField } onFocus={this.handleOnFocus} withRef={true} ref="LV4" placeholder={this.state.p4Percentage} onChange={(event) => {this.handlePercentageChange("p4Percentage", event)}} onKeyPress={(event) => {
                                                    this.handleKeyPress('LV5', event)
                                                }}/>
                                            </div>
                                          </div>
                                          <span className="equal-sign">=</span>
                                        </Col>
                                        <Col xs={ 4 }>
                                          <div className="form-group">
                                            <label className="col-xs-4"><Translate value="lv_4" /><span className="dollar-sign">$</span></label>
                                            <div className="col-xs-7">
                                              <Field name="PriceLv4" className="control-label" component={ ControlledInputField } onFocus={this.handleOnFocus} withRef={true} ref="LV4_2" placeholder={this.state.priceLv4.toFixed(2) || 0} onChange={(event) => {this.handlePriceChange("priceLv4", event)}} onKeyPress={(event) => {
                                                    this.handleKeyPress('LV5_2', event)
                                                }}/>
                                            </div>
                                          </div>
                                        </Col>
                                        <Col xs={ 4 }>
                                          <div className="form-group">
                                            <label className="col-md-4"><Translate value="lv_4" /><span className="dollar-sign">$</span></label>
                                            <div className="col-md-8">
                                              <Field name="PriceLv1Rounded" className="control-label" component={ DisabledInputField } placeholder={this.roundUp(this.state.priceLv4)} />
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs={ 12 } className="centerStyle">
                                      <Row>
                                        <Col xs={ 4 }>
                                          <div className="form-group">
                                            <label className="col-xs-4"><Translate value="lv_5" /> %</label>
                                            <div className="col-xs-7">
                                              <Field name="P5Percentage" className="control-label" component={ ControlledInputField } onFocus={this.handleOnFocus} withRef={true} ref="LV5" placeholder={this.state.p5Percentage} onChange={(event) => {this.handlePercentageChange("p5Percentage", event)}} onKeyPress={(event) => {
                                                this.handleKeyPress('LV1_2', event)
                                              }}/>
                                            </div>
                                          </div>
                                          <span className="equal-sign">=</span>
                                        </Col>
                                        <Col xs={ 4 }>
                                          <div className="form-group">
                                            <label className="col-xs-4"><Translate value="lv_5" /><span className="dollar-sign">$</span></label>
                                            <div className="col-xs-7">
                                              <Field name="PriceLv5" className="control-label" component={ ControlledInputField } onFocus={this.handleOnFocus} withRef={true} ref="LV5_2" placeholder={this.state.priceLv5.toFixed(2) || 0} onChange={(event) => {this.handlePriceChange("priceLv5", event)}} onKeyPress={(event) => {
                                                    if (event.charCode == 13) {
                                                      event.preventDefault();
                                                      this.refs["CRVOptions"].getRenderedComponent().refs.select.focus();
                                                    }
                                                }}/>
                                            </div>
                                          </div>
                                        </Col>
                                        <Col xs={ 4 }>
                                          <div className="form-group">
                                            <label className="col-md-4"><Translate value="lv_5" /><span className="dollar-sign">$</span></label>
                                            <div className="col-md-8">
                                              <Field name="PriceLv1Rounded" className="control-label" component={ DisabledInputField } placeholder={this.roundUp(this.state.priceLv5)} />
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </Panel>
                              </Col>
                            </Row>
                          </Col> */} {/* End Convert Details */}

                  {/* <Col xs={ 3 }>
                            <Row>
                              <Col xs={ 12 }>
                                <Panel id="inventory-details-panel" header={inventoryDetailsPanelHeader}>
                                  <Row className="padding-controler">
                                    <Col xs={ 6 }>
                                      <label><Translate value="product_barcode" /></label>
                                        <Field name="ProductBarcode" withRef={true} ref="ProductBarcode" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                            this.handleKeyPress('RefBarcode', event)
                                        }}/>
                                    </Col>
                                    <Col xs={ 6 }>
                                      <label><Translate value="reference_barcode" /></label>
                                        <Field name="RefBarcode" withRef={true} ref="RefBarcode" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                            this.handleKeyPress('ShelfLife', event)
                                        }}/>
                                    </Col>
                                  </Row>
                                  <h3><Translate value="location" /> / <Translate value="bin_range" /></h3>
                                  <Row>
                                    <Col xs={ 6 }>
                                      <div className="form-group">
                                        <label className="col-xs-3"><Translate value="zone" /></label>
                                        <div className="col-xs-9">
                                          <Field name="DefaultZone" withRef={true} ref="DefaultZone" component={ InputField } onFocus={this.handleOnFocus} />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs={ 6 }>
                                      <div className="form-group">
                                        <label className="col-xs-4 mr-lg"><Translate value="shelf_life" /></label>
                                        <div className="col-xs-5">
                                          <Field name="ShiftLife" withRef={true} ref="ShelfLife" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                              if (event.charCode == 13)
                                                event.preventDefault();
                                          }}/>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    {this.renderDefaultBinRange()}
                                  </Row>
                                </Panel>
                              </Col>
                            </Row>
                          </Col>
                        </Row> */}{/* Detail Panels */}

                  {/* Product Order History Table */}
                  <h1><Translate value="purchase_history" /></h1>
                  <Row>
                    <Col xs={12}>
                      <Panel id="product-order-history">
                              {this.renderTableFilter()}
                              {this.renderTable()}
                            </Panel>
                    </Col>
                  </Row>
                  {/* End Product Order History Table */}
                  <br />
                  {/* Purchase Order Table */}
                  <h1><Translate value="sales_history" /></h1>
                  <Row>
                    <Col xs={12}>
                      <Panel id="inventory-order-history" className="position-relative table-collapse-fix">
                              {this.renderToolbarFilter()}
                              {this.renderProductsTable()}
                            </Panel>
                    </Col>
                  </Row>
                  {/* End Purchase Order Table */}

                  {/* Loaders */}
                  <Row>
                    { this.props.quickInventoryAdjustmentIsEditing && <div className="alert alert-info"><Spinner /><Translate value="uploading" /></div> }
                    { this.props.quickInventoryAdjustmentEdited && <div className="alert alert-success"><Translate value="saved" /></div>}
                    { this.props.quickInventoryAdjustmentEditError && <div className="alert alert-danger marginTopStyle" >{this.props.quickInventoryAdjustmentEditError}</div> }
                  </Row> {/* End Loaders */}
                </Col>
              </Row> {/* End Row Wrapper */}
            </Grid>
          </form>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.adjustmentOpen} onCloseClicked={this.closeAdjustment}>
            <ConfirmActionModal case="confirmPassword" closeC={this.enableAdjustment} checkPasswordFailure={this.props.checkPasswordFailure} />
          </SkyLightStateless>
        </ContentWrapper>
      //---------------
      // End HTML
      //---------------

      );
    }
}

export default InventoryDetail;

const renderSaleRadios = (props) => {
  const titleClass = classNames('col-xs-4');
  return (
    <div id="stopSale" className="form-group" >
      <label className={titleClass}>
        <input
          {...props.input}
          type="radio"
          value="OnSale"
          checked={props.input.value === 'OnSale'}
        />
        <Translate value="on_sale" />
      </label>
      <label className="col-xs-4">
        <input
          {...props.input}
          type="radio"
          value="StopSale"
          checked={props.input.value === 'StopSale'}
        />
        <Translate value="stop_sale" />
      </label>
      <label className="col-xs-3 pull-right">
        <input
          {...props.input}
          type="radio"
          value="OnHold"
          checked={props.input.value === 'OnHold'}
        />
        <Translate value="on_hold" />
      </label>
    </div>
  );
};

const renderRadios = props => (
  <div className="form-group">
    <label className="col-xs-4">
      <Translate value={`${props.labelName}`} />
    </label>
    <div className="col-xs-2 ">
      <input
        {...props.input}
        type="radio"
        value="true"
        checked={props.input.value === true || props.input.value === 'true'
               || (props.input.name === 'IsOverSaleable' && props.input.value !== false && props.input.value !== 'false')}
      />
      <Translate value="yes" />
    </div>
    <div className="col-xs-2">
      <input
        {...props.input}
        type="radio"
        value="false"
        checked={props.input.value === false || props.input.value === 'false'}
      />
      <Translate value="no" />
    </div>
  </div>
);

const convertNumRadios = props => (
  <div className="form-group">
    <label className="col-xs-4">
      <Translate value="convert_type" />
    </label>
    <div className="col-xs-3 text-nowrap">
      <input
        {...props.input}
        type="radio"
        value="weight"
        checked={props.input.value === 'weight'}
      />
      <Translate value="by_weight" />
    </div>
    <div className="col-xs-3 text-nowrap">
      <input
        {...props.input}
        type="radio"
        value="unit"
        checked={props.input.value === 'unit'}
      />
      <Translate value="by_unit" />
    </div>
  </div>
);

const renderConvertDetailsList = (props) => {
  const { fields } = props;
  return (
    <Row>
      <Col xs={12}>
        <Row>
          <Col xs={12}>
            {fields.map((Product, index) =>
                (<div>
                  <Row key={index} className="prod-qty-adjuster">
                    <Col xs={12}>
                      <Row>
                        <Col xs={6} className="prod-no-related">
                          <div className="form-group">
                            <label className="col-xs-5"><Translate value="prod_num" /></label>
                            <div className="col-xs-7">
                              <Field name={`${Product}.ProductNum`} className="control-label" component={DisabledInputField} />
                            </div>
                          </div>
                        </Col>
                        <Col xs={4} className="convert-qty col-xs-offset-1">
                          <div className="form-group">
                            <label className="col-xs-3"><Translate value="qty" /></label>
                            <div className="col-xs-4">
                              <Field name={`${Product}.ConvertNum`} className="control-label" component={DisabledInputField} />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                 </div>)) }
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const renderBinRangeList = (props) => {
  const { fields, binOptions, levelOptions } = props;
  return (
    <Row><Col xs={12} className="add-bin-range-section">
      <Row><Col xs={12}>
        <Button
          bsStyle="primary"
          type="button"
          onClick={() => {
                  fields.push({}); // pushes empty child field onto the end of the array
              }}
        > <em className="fa fa-plus" />
        </Button>
           </Col>
      </Row>
      <Row><Col xs={12}>
        {!fields.length && <div className="marginTopStyle" ><Translate value="no" /> <Translate value="bin_range" /></div>}
        {fields.map((Bin, index) =>
          (<Row key={index} className="additional-bin-range">
            <Col xs={12}>
              <h4><Translate value="bin_range" /> { `#${index + 1}` }</h4>
              <Row>
                <Col xs={5}>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="bin" /></label>
                    <div className="col-xs-9">
                        <Field name={`${Bin}.DefaultBin`} component={Selection} options={binOptions} />
                      </div>
                  </div>
                </Col>
                <Col xs={5}>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="level" /></label>
                    <div className="col-xs-9">
                        <Field name={`${Bin}.Default_Level`} component={Selection} options={levelOptions} />
                      </div>
                  </div>
                </Col>
                <Col xs={2}>
                  <Button
                    bsStyle="danger"
                    className="remove-btn"
                    type="button"
                    onClick={() => {
                                fields.remove(index); // remove from index
                              }}
                  >
                    <em className="fa fa-trash" />
                  </Button>
                </Col>
              </Row>
            </Col>
           </Row>)) }
           </Col>
      </Row>
         </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/inventoryDetail.jsx